import { REST } from '../api/ApiService';

export interface ICertificate {
  expiration: number;
  path: string;
  serverCertificateId: string;
  serverCertificateName: string;
  uploadDate: number;
}

export class CertificateReader {
  public static listCertificates(): Promise<ICertificate[]> {
    return REST('/certificates').get();
  }

  public static listCertificatesByProvider(cloudProvider: string): Promise<ICertificate[]> {
    return REST('/certificates').path(cloudProvider).get();
  }
}
